"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyCategories = void 0;
const property_type_1 = require("./property_type");
const property_sub_type_1 = require("./property_sub_type");
exports.PropertyCategories = Object.freeze({
    House: {
        sale: [
            {
                types: [
                    property_type_1.PropertyType.Residential,
                    property_type_1.PropertyType.ResidentialIncome,
                    property_type_1.PropertyType.ManufacturedInPark,
                ],
                subTypes: [
                    property_sub_type_1.PropertySubType.SingleFamilyResidence,
                    property_sub_type_1.PropertySubType.MultiFamily,
                    property_sub_type_1.PropertySubType.ManufacturedHome,
                    property_sub_type_1.PropertySubType.ManufacturedOnLand,
                    property_sub_type_1.PropertySubType.Cabin,
                    property_sub_type_1.PropertySubType.Duplex,
                    property_sub_type_1.PropertySubType.Triplex,
                    property_sub_type_1.PropertySubType.Quadruplex,
                    property_sub_type_1.PropertySubType.OwnYourOwn,
                ],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.ResidentialLease],
                subTypes: [
                    property_sub_type_1.PropertySubType.SingleFamilyResidence,
                    property_sub_type_1.PropertySubType.MultiFamily,
                    property_sub_type_1.PropertySubType.ManufacturedHome,
                    property_sub_type_1.PropertySubType.ManufacturedOnLand,
                    property_sub_type_1.PropertySubType.Cabin,
                    property_sub_type_1.PropertySubType.Duplex,
                    property_sub_type_1.PropertySubType.Triplex,
                    property_sub_type_1.PropertySubType.Quadruplex,
                    property_sub_type_1.PropertySubType.OwnYourOwn,
                ],
            },
        ],
    },
    Townhouse: {
        sale: [
            {
                types: [property_type_1.PropertyType.Residential, property_type_1.PropertyType.ResidentialIncome],
                subTypes: [property_sub_type_1.PropertySubType.Townhouse],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.ResidentialLease],
                subTypes: [property_sub_type_1.PropertySubType.Townhouse],
            },
        ],
    },
    Condo: {
        sale: [
            {
                types: [property_type_1.PropertyType.Residential, property_type_1.PropertyType.ResidentialIncome],
                subTypes: [
                    property_sub_type_1.PropertySubType.Apartment,
                    property_sub_type_1.PropertySubType.Condominium,
                    property_sub_type_1.PropertySubType.StockCooperative,
                    property_sub_type_1.PropertySubType.Timeshare,
                    property_sub_type_1.PropertySubType.Apartment_Condominium,
                ],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.ResidentialLease],
                subTypes: [
                    property_sub_type_1.PropertySubType.Apartment,
                    property_sub_type_1.PropertySubType.Condominium,
                    property_sub_type_1.PropertySubType.StockCooperative,
                    property_sub_type_1.PropertySubType.Timeshare,
                    property_sub_type_1.PropertySubType.Apartment_Condominium,
                ],
            },
        ],
    },
    Farm: {
        sale: [
            {
                types: [property_type_1.PropertyType.Farm],
                subTypes: [],
            },
            {
                types: [property_type_1.PropertyType.Residential, property_type_1.PropertyType.ResidentialIncome],
                subTypes: [
                    property_sub_type_1.PropertySubType.FarmSubType,
                    property_sub_type_1.PropertySubType.Agriculture,
                    property_sub_type_1.PropertySubType.Ranch,
                ],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.ResidentialLease],
                subTypes: [
                    property_sub_type_1.PropertySubType.FarmSubType,
                    property_sub_type_1.PropertySubType.Agriculture,
                    property_sub_type_1.PropertySubType.Ranch,
                    property_sub_type_1.PropertySubType.UnimprovedLand,
                ],
            },
        ],
    },
    Land: {
        sale: [
            {
                types: [property_type_1.PropertyType.Land],
                subTypes: [],
            },
            {
                types: [property_type_1.PropertyType.Residential, property_type_1.PropertyType.ResidentialIncome],
                subTypes: [
                    property_sub_type_1.PropertySubType.UnimprovedLand,
                    property_sub_type_1.PropertySubType.ResidentialLand,
                ],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.ResidentialLease],
                subTypes: [
                    property_sub_type_1.PropertySubType.UnimprovedLand,
                    property_sub_type_1.PropertySubType.ResidentialLand,
                ],
            },
        ],
    },
    Commercial: {
        sale: [
            {
                types: [property_type_1.PropertyType.CommercialSale],
                subTypes: [],
            },
            {
                types: [property_type_1.PropertyType.Residential, property_type_1.PropertyType.ResidentialIncome],
                subTypes: [
                    property_sub_type_1.PropertySubType.Office,
                    property_sub_type_1.PropertySubType.Retail,
                    property_sub_type_1.PropertySubType.Warehouse,
                    property_sub_type_1.PropertySubType.HotelMotel,
                    property_sub_type_1.PropertySubType.HotelMotelESP,
                    property_sub_type_1.PropertySubType.Industrial,
                    property_sub_type_1.PropertySubType.MixedUse,
                    property_sub_type_1.PropertySubType.Business,
                ],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.CommercialLease],
                subTypes: [
                    property_sub_type_1.PropertySubType.Office,
                    property_sub_type_1.PropertySubType.Retail,
                    property_sub_type_1.PropertySubType.Warehouse,
                    property_sub_type_1.PropertySubType.HotelMotel,
                    property_sub_type_1.PropertySubType.HotelMotelESP,
                    property_sub_type_1.PropertySubType.Industrial,
                    property_sub_type_1.PropertySubType.MixedUse,
                    property_sub_type_1.PropertySubType.Business,
                ],
            },
        ],
    },
    Other: {
        sale: [
            {
                types: [property_type_1.PropertyType.Other],
                subTypes: [],
            },
        ],
        rent: [
            {
                types: [property_type_1.PropertyType.OtherLease],
                subTypes: [],
            },
        ],
    },
});
//# sourceMappingURL=property_filter.js.map